import { useEffect, useRef, useState, } from "react";
import User from '../../components/user';
import Home from '../../components/home';

import { Link } from "react-router-dom";
import useUserName from '../../common/hooks/useUserName';
import { locationAPI } from '../../api/locationAPI';

import LogOut from '../../components/logOut';

import './mainMenu.css';

import Spinner from "../../components/spinner";

export default function MainMenu({ logOut }) {
    const isMounted = useRef(false);
    const [locations, setLocations] = useState([]);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isRoomDelivery, setIsRoomDelivery] = useState(false);

    const { userName } = useUserName();

    useEffect(() => {
        if (isMounted.current === false) {
            isMounted.current = true;
            setIsProcessing(true);
            locationAPI.getDeliveryLocations().then((data) => {
                setLocations(data.locations);
                setIsRoomDelivery(data.isRoomDelivery);
            }).finally(() => setIsProcessing(false));
        }
    }, [])

    const Header = () => {
        return (
            <div>
                <Home />
                <User />
            </div>
        );
    }

    return (
        <>
            <Header />
            <div className="Bg">
                <div className="row">
                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1"></div>
                    <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10 p-2">
                        <div className="row contentMainMenu rounded">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 text-center">
                                <div className="row">
                                    <div className="col-0 col-sm-11 col-md-1 col-lg-4 col-xl-4 col-xxl-4"></div>
                                    <div className="col-12 col-sm-10 col-md-10 col-lg-4 col-xl-4 col-xxl-4">
                                        <h4>Delivery location</h4>
                                        {isProcessing && <Spinner />}
                                        {isProcessing === false &&
                                            <ul class="list-group">
                                                <Link to={"/postouch"}
                                                    state={{
                                                        selectedTableNo: '', backNavigationPath: "/room/mainmenu",
                                                        selectedMode: 'Room - ' + userName,
                                                        selectedLocCode: userName, selectedRoomNo: userName
                                                    }}
                                                >
                                                    {
                                                        isRoomDelivery === true ?
                                                            <li className="list-group-item btn btn bg-danger text-white">
                                                                {userName}
                                                            </li>
                                                            :
                                                            <li className="list-group-item btn bg-success text-white">
                                                                {userName}
                                                            </li>
                                                    }
                                                    
                                                </Link>
                                                {
                                                    locations.map((data, index) => (
                                                        <Link to={"/postouch"} key={data.locCode}
                                                            state={{
                                                                selectedTableNo: '', backNavigationPath: "/room/mainmenu",
                                                                selectedRoomNo: userName,
                                                                selectedMode: 'Room - ' + userName,
                                                                selectedLocCode: data.locCode
                                                            }}
                                                        >
                                                            {
                                                                data.isOccupied === true ?
                                                                    <li className="list-group-item btn bg-danger text-white mt-1" key={data.locCode}>
                                                                        {data.locName}
                                                                    </li>
                                                                    :
                                                                    <li className="list-group-item btn bg-success text-white mt-1" key={data.locCode}>
                                                                        {data.locName}
                                                                    </li>
                                                            }
                                                            
                                                        </Link>
                                                    ))
                                                }
                                            </ul>
                                        }
                                    </div>
                                    <div className="col-0 col-sm-11 col-md-1 col-lg-4 col-xl-4 col-xxl-4"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1"></div>
                </div>
            </div>
            <LogOut logOut={logOut} />
        </>
    );
}